const ROOT = 'Login/password/createPassword';

export const FETCH_CREATEPASSWORD_REQUEST = `${ROOT}/FETCH_CREATEPASSWORD_REQUEST`;
export const FETCH_CREATEPASSWORD_SUCCESS = `${ROOT}/FETCH_CREATEPASSWORD_SUCCESS`;
export const FETCH_CREATEPASSWORD_FAILURE = `${ROOT}/FETCH_CREATEPASSWORD_FAILURE`;
